module.exports = __webpack_public_path__ + "static/media/dedek.dd01faee.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/image/Team/dedek.jpeg
// module id = 172
// module chunks = 0